// extracted by mini-css-extract-plugin
export default {"contentWrapper":"BetaReportArea_contentWrapper__3S0Gv","appear":"BetaReportArea_appear__WLC0j","dashboardWrapper":"BetaReportArea_dashboardWrapper__Rw7Cz"};